/**************************************************
 * Nombre:       Detalle_Producto_Img_Caracteristicas_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {Check, East, FiberManualRecord, ShoppingCartOutlined, WhatsApp} from '@mui/icons-material'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import {irUrl} from "../../../Utilidades/irUrl";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "../../Dialogos/Dialogo_Politicas";
import {useFuncionesCarrito} from "../../../Modulo_Carrito_Compra/Hooks/useFuncionesCarrito";
import {adap_producto} from "../../../Modulo_Carrito_Compra/Adaptadores/adap_producto";
import {useCarritoCompras} from "../../../Modulo_Carrito_Compra/Hooks/useCarritoCompras";
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";
import {valorConDescuento} from "../../../CodCliente/valorConDescuento";
import {obtenerPorcentaje} from "../../../CodCliente/obtenerPorcentaje";

const Detalle_Producto_Img_Caracteristicas_Caracteristicas = ({producto, Tallas, seleccionada}) => {
    const {sCell, masSM} = useResponsive()
    const cData = useContext(contexApp)
    const {adicionarProducto, verificarProductoCarrito} = useFuncionesCarrito()
    const {abrir: abrirCarrito, DialogoCarrito} = useCarritoCompras()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})
    const [esBlack, setEsBlack] = useState(false)


    const agregarProducto = () => {

        let prod = adap_producto({producto, presentacion: seleccionada})
        if (esBlack) {
            prod.valor = valorConDescuento({valor: producto.valor, descuento: 20})
            prod.porcentaje = 20
        }

        if (producto.rebajado > 0) {
            prod.valor = producto.rebajado
            prod.porcentaje = obtenerPorcentaje({valor: producto.valor, rebajado: producto.rebajado})
        }

        adicionarProducto(prod)

    }

    const click = (id) => {
        switch (id) {
            case 'compra':
                abrir({texto: cData.configuraciones.politica_envio})
                break
            case 'datos':
                abrir({texto: cData.configuraciones.politica_protenccion})
                break
        }
    }

    useEffect(() => {

        if (cData.configuraciones?.black === 'Si') {
            setEsBlack(true)
        } else {
            setEsBlack(false)
        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: theme.palette.primary.main}}
        >

            <Dialogo/>

            <DialogoCarrito/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: 0.5}}>
                <Typography sx={{fontSize: !masSM ? 16 : 20, fontWeight: 400}}>{producto.coleccion}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography
                    sx={{fontSize: !masSM ? 32 : 42, fontFamily: 'Dm Serif Display', fontWeight: 400, lineHeight: 1}}>
                    {producto.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Typography sx={{
                    fontSize: !masSM ? 16 : 18,
                    fontWeight: 300,
                    minHeight: !masSM ? 'auto' : 110,
                    lineHeight: 1.3
                }}>
                    {producto.descripcion}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                <Typography sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    lineHeight: 1.3
                }}>
                    Talla / Tipo
                </Typography>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 5}} sx={{mt: 1}}>
                <Tallas/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{mt: -6}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    {producto.guia_tallas === 'Si' &&
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                            <Button
                                onClick={() => irUrl(producto.pdf ? producto.pdf : cData.configuraciones.guia_tallas)}
                                variant={'text'} endIcon={<East/>}
                                sx={{px: 1}}
                            >GUIA DE TALLAS</Button>
                        </Grid>
                    }

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{mt: producto.guia_tallas === 'Si' ? 1 : 6, pl: 0}}>
                        {
                            esBlack ?
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{
                                            fontSize: 14,
                                            fontWeight: 400,
                                            textDecoration: 'line-through',
                                        }}>{formatoMoneda(producto.valor)}</Typography>

                                        {producto.rebajado > 0 &&

                                            <Typography sx={{
                                                fontSize: 14,
                                                fontWeight: 400,
                                                pl: 1
                                            }}>-{obtenerPorcentaje({
                                                valor: producto.valor,
                                                rebajado: producto.rebajado
                                            })}%</Typography>

                                        }

                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{
                                            fontSize: 30,
                                            fontWeight: 600,
                                            lineHeight: 1.1
                                        }}>

                                            {producto.rebajado > 0 ?
                                                formatoMoneda(producto.rebajado)
                                                :
                                                formatoMoneda(valorConDescuento({
                                                    valor: producto.valor,
                                                    descuento: 20
                                                }))
                                            }


                                        </Typography>
                                    </Grid>

                                </Grid>

                                :

                                <Typography
                                    sx={{fontSize: 30, fontWeight: 600}}>{formatoMoneda(producto.valor)}</Typography>

                        }

                    </Grid>


                </Grid>
            </Grid>

            {seleccionada && seleccionada.cantidad && parseInt(seleccionada.cantidad) > 0 ?

                <>
                    {!verificarProductoCarrito(producto) ?
                        <Grid container size={{xs: 6, sm: 12, md: 5}} sx={{mt: 2, px: sCell ? 1 : 0}}>
                            <Button
                                onClick={() => agregarProducto()}
                                fullWidth={sCell}
                                variant={'outlined'} sx={{px: sCell ? 1 : 3}}>Agregar al carrito</Button>
                        </Grid>
                        :

                        <Grid container size={{xs: 6, sm: 12, md: 4}} sx={{mt: 2, px: sCell ? 1 : 0}}>
                            <Typography sx={{lineHeight: 1.1}}>Producto ya agregado en carrito</Typography>
                        </Grid>
                    }

                    <Grid container size={{xs: 6, sm: 12, md: 5}} sx={{mt: 2, px: sCell ? 1 : 0}}>
                        <Button
                            onClick={() => {
                                if (!verificarProductoCarrito(producto)) {
                                    agregarProducto()
                                }
                                abrirCarrito()

                            }}

                            startIcon={!verificarProductoCarrito(producto) ? <Check/> : <ShoppingCartOutlined/>}
                            fullWidth={sCell}
                            sx={{
                                border: 1,
                                borderColor: theme.palette.primary.main,
                                px: sCell ? 1 : 3
                            }}>{verificarProductoCarrito(producto) ? 'Ver Carrito' : 'Compara ahora'}</Button>
                    </Grid>
                </>
                :

                <>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                        <Typography sx={{fontSize: 24, fontWeight: 600}}>Sin Stock</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{mt: 0}}>
                        <Typography sx={{fontSize: 16, lineHeight: 1.1}}>Esta prenda ha sido muy deseada y actualmente
                            no está
                            disponible.
                            Ponte en contacto con nosotros para generar tu pre-orden y asegurar la tuya.</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                        <Button
                            onClick={() => iniciarChatWass({mensaje: 'Hola quisiera reservar ' + producto.nombre})}
                            startIcon={<WhatsApp/>} sx={{borderRadius: 0, pb: 1}}>Solicitar</Button>
                    </Grid>

                </>


            }


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                <Button
                    onClick={() => click('compra')}
                    variant={'text'} startIcon={<FiberManualRecord/>}
                    sx={{px: 1, textTransform: 'none', fontSize: 16, fontWeight: 400}}
                >Políticas de compra</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -1.5}}>
                <Button
                    onClick={() => click('datos')}
                    variant={'text'} startIcon={<FiberManualRecord/>}
                    sx={{px: 1, textTransform: 'none', fontSize: 16, fontWeight: 400}}
                >Políticas de privacidad</Button>
            </Grid>


        </Grid>
    )

}
export default Detalle_Producto_Img_Caracteristicas_Caracteristicas